<template>
  <div>
    <FieldsetBox>
      <template #header v-if="showHeader">
      <div style="width: 50%; margin: -3em auto auto auto; background: #fff;">
        <SVGCarLady />
      </div>
    </template>
      <template #content>
      <SmallCarItinerary :journey="sol"></SmallCarItinerary>
    </template>
      <template #footer>
      <b-button  size="is-small"
                 type="normal"
                 @click="checkDelete()"
                 icon-right="delete"
                 inverted
                 class="ml-1"
      />
      <b-button  size="is-small"
                 type="normal"
                 @click="ok()"
                 icon-right="pencil"
                 inverted
                 class="ml-1"
      />
    </template>
    </FieldsetBox>
  </div>
</template>

<script>
  import SmallCarItinerary from './SmallCarItinerary.vue';
  import SVGCarLady from "../SVGs/SVG-CarLady";
  import FieldsetBox from "../UI/FieldsetBox";

  export default {
    name: 'ItineraryCar',
    components: {
      SmallCarItinerary,
      SVGCarLady,
      FieldsetBox,
    },
    props: {
        sol: Object,
        showHeader: {
          type: Boolean,
          default: true,
        }
      },
    data: function () {
        return {
        }
      },
    methods: {
      ok() {
        this.$emit('add');
      },
      checkDelete(){
          this.$buefy.dialog.confirm({
              message: 'Are you sure you would like to delete this rental car from your itinerary?',
              confirmText: 'Delete',
              type: 'is-danger',
              hasIcon: true,
              onConfirm: () => this.del()
          })

      },
      del(){
        this.$store.dispatch('bookTravel/alterCarResult', {})
      },
    },
    mounted() {
      // console.log(this.sol)
    }
  }
</script>

<style scoped>
</style>
